<div class="pageWrapper active">
  <p-drawer [(visible)]="sidebarMenu" [baseZIndex]="101" [closeOnEscape]="false" [modal]="false">
    <div class="leftNavigation no-print clearfix">
      <app-page-header></app-page-header>
    </div>
  </p-drawer>

  <div class="contentWrapper" [ngClass]="sidebarMenu ? 'ml-65' : ''">
    <div class="container-fluid">
      <header class="header">
        <nav class="navbar navbar-light navbar-expand-lg">
          <div class="navbar-brand col-md-4 col-5">
            <div class="d-inline-flex">
              <div class="d-none d-md-flex">
                <span class="material-symbols-outlined notranslate">
                  {{ pageIcon }}
                </span>
              </div>
              <div class="d-md-none d-block clsMenuBar">
                <p-button
                  type="button"
                  styleClass="py-1"
                  (click)="sidebar()"
                  (keydown.enter)="sidebar()"
                  aria-label="Toggle Sidebar">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#fff">
                    <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
                  </svg>
                </p-button>
              </div>
            </div>
            <div class="d-flex ps-3 content-header align-items-center">
              <div class="d-md-flex flex-column">
                <small class="mb-0">{{ getUserReportingRole ? 'Reporting Role' : userDetails?.roledesc }}</small>
                <div class="content-text">{{ pagename }}</div>
              </div>
            </div>
          </div>
          @if (false) {
            <div id="navbarSupportedContent">
              <ul class="navbar-nav mr-auto flex-row">
                <li class="nav-item pe-2 me-2 border-right">
                  <p-knob [(ngModel)]="completevalue" [size]="35"></p-knob>
                </li>
                <li class="nav-item">
                  <div class="d-flex align-items-center h-100 referral-link">
                    <a href="javascript:void(0)" (click)="openActivity()">
                      <em class="pi pi-book me-1"></em>
                      <span class="font-weight-600">Referral Activity</span>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          }
          <div id="dashboardItems" class="dashboard-list col-md-8 col-7">
            <ul class="navbar-nav ms-auto flex-row">
              <li class="nav-item notification d-flex align-items-center" *showField="'APP_HEADER_STATUS'">
                <p-select
                  class="availability-select"
                  [options]="statuses"
                  [(ngModel)]="selectedStatus"
                  optionLabel="name"
                  optionValue="code"
                  placeholder="Select Status"
                  (onChange)="updateStatus($event.value)">
                </p-select>
              </li>
              <li class="nav-item notification d-flex align-items-center organization" *showField="'APP_HEADER_ORG'">
                @if (disable) {
                  <label class="me-4 org-label" for="organization">
                    <span class="pi pi-sitemap"></span> {{ orgName }}
                  </label>
                }
                @if (!disable) {
                  <p-treeSelect
                    class="organization-select"
                    [options]="orgOptions"
                    [metaKeySelection]="true"
                    selectionMode="single"
                    (onNodeSelect)="organisationSelect($event)"
                    inputId="organization"
                    [(ngModel)]="selectedOrg"
                    placeholder="Select Organization">
                  </p-treeSelect>
                }
              </li>

              @if (showLanguage) {
                <li class="nav-item notification d-flex clsMenuLangBtn">
                  <a
                    class="nav-link d-flex align-items-center"
                    #langselect
                    (click)="showLanguageDialog()"
                    tabindex="0"
                    title="choose language translater to change English or Spanish">
                    <div class="menuIcons d-inline-block position-relative">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24px"
                        viewBox="0 -960 960 960"
                        width="24px"
                        fill="#0059bf">
                        <path
                          d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-82q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z" />
                      </svg>
                    </div>
                    <span aria-hidden="true">English</span>
                  </a>
                </li>
              }

              @if (
                userDetails?.role !== 'casaadmin' &&
                userDetails?.role !== 'dfcsadmin' &&
                userDetails?.role !== 'reportingrole'
              ) {
                <li class="nav-item notification d-flex">
                  <a
                    class="nav-link d-flex align-items-center"
                    matTooltip="User Notification"
                    (keyup.enter)="gotoNotification()"
                    tabindex="0">
                    <div
                      class="menuIcons d-inline-block position-relative"
                      (click)="gotoNotification()"
                      (keydown.enter)="gotoNotification()">
                      @if (showCount) {
                        <small aria-hidden="true" class="badge notif-count">{{
                          notificationCount ? notificationCount : 0
                        }}</small>
                      }
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24px"
                        viewBox="0 -960 960 960"
                        width="24px"
                        fill="#0059bf">
                        <path
                          d="M180-204.62v-59.99h72.31v-298.47q0-80.69 49.81-142.69 49.8-62 127.88-79.31V-810q0-20.83 14.57-35.42Q459.14-860 479.95-860q20.82 0 35.43 14.58Q530-830.83 530-810v24.92q78.08 17.31 127.88 79.31 49.81 62 49.81 142.69v298.47H780v59.99H180ZM479.93-92.31q-29.85 0-51.04-21.24-21.2-21.24-21.2-51.07h144.62q0 29.93-21.26 51.12-21.26 21.19-51.12 21.19Z" />
                      </svg>
                      <span class="sr-only">User Notification</span>
                    </div>
                  </a>
                </li>
              }

              @if (
                userDetails?.role !== 'casaadmin' &&
                userDetails?.role !== 'dfcsadmin' &&
                userDetails?.role !== 'reportingrole'
              ) {
                <li class="nav-item notification d-flex">
                  <a
                    class="nav-link d-flex align-items-center"
                    (keyup.enter)="routeToChat()"
                    matTooltip="Chat Notification"
                    tabindex="0">
                    <div
                      class="menuIcons d-inline-block position-relative"
                      (click)="routeToChat()"
                      (keydown.enter)="routeToChat()">
                      <small aria-hidden="true" class="badge notif-count">{{ unreadMessages?.length || 0 }}</small>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24px"
                        viewBox="0 -960 960 960"
                        width="24px"
                        fill="#0059bf">
                        <path
                          d="M100-118.46v-669.23Q100-818 121-839q21-21 51.31-21h615.38Q818-860 839-839q21 21 21 51.31v455.38Q860-302 839-281q-21 21-51.31 21H241.54L100-118.46ZM250-410h300v-60H250v60Zm0-120h460v-60H250v60Zm0-120h460v-60H250v60Z" />
                      </svg>
                      <span class="sr-only">Chat Notification</span>
                    </div>
                  </a>
                </li>
              }
              <li class="nav-item overllmenu d-flex dropdown" *showField="'APP_HEADER_CONNECTIONS'">
                <a
                  class="nav-link d-flex align-items-center"
                  href="javascript:void(0)"
                  id="navbarDropdownMenuLinkTwo"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <div class="menuIcons">
                    <span class="material-symbols-outlined notranslate material-icons">apps</span>
                  </div>
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLinkOne">
                  <div class="row">
                    <div class="col">
                      <a (click)="gotoVideoConfig()">
                        <figure class="text-center">
                          <img src="/assets/images/video-call.svg" alt="video-call" width="28" />
                          <figcaption class="mt-1">Video Call</figcaption>
                        </figure>
                      </a>
                    </div>
                    <div class="col">
                      <a (click)="gotoEmailTemp()">
                        <figure class="text-center">
                          <img src="/assets/images/Email.svg" alt="emailtag" width="28" />
                          <figcaption class="mt-1">Email</figcaption>
                        </figure>
                      </a>
                    </div>
                    <div class="col"></div>
                  </div>
                </div>
              </li>

              <li class="nav-item notification d-flex">
                <a
                  class="nav-link d-flex align-items-center cursor-pointer"
                  (click)="menu.toggle($event)"
                  aria-label="User Profile Settings">
                  <span
                    #profileRef
                    class="username d-none d-sm-block"
                    [matTooltipPosition]="'below'"
                    matTooltip="User Profile Settings">
                    {{ showname }}
                  </span>
                </a>
                <p-menu #menu [popup]="true" [model]="visibleMenuItems" appendTo="body" styleClass="profile-menu">
                </p-menu>
              </li>

              <li class="nav-item notification d-flex">
                <a
                  class="nav-link d-flex align-items-center"
                  data-container="body"
                  id="logout"
                  (keyup.enter)="onLoggedout()"
                  matTooltip="Logout"
                  tabindex="0">
                  <div
                    class="menuIcons d-inline-block position-relative"
                    (click)="onLoggedout()"
                    (keydown.enter)="onLoggedout()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512" fill="none">
                      <path
                        d="M363.335 488C363.335 494.365 360.806 500.47 356.306 504.971C351.805 509.471 345.7 512 339.335 512H113.082C91.872 511.976 71.5375 503.54 56.5398 488.542C41.542 473.544 33.1059 453.21 33.082 432V80C33.1059 58.79 41.542 38.4555 56.5398 23.4578C71.5375 8.46002 91.872 0.0238211 113.082 0L339.335 0C345.7 0 351.805 2.52856 356.306 7.02944C360.806 11.5303 363.335 17.6348 363.335 24C363.335 30.3652 360.806 36.4697 356.306 40.9706C351.805 45.4714 345.7 48 339.335 48H113.082C104.598 48.0093 96.464 51.3837 90.4648 57.3828C84.4657 63.382 81.0913 71.5159 81.082 80V432C81.091 440.484 84.4653 448.618 90.4646 454.617C96.4638 460.617 104.598 463.991 113.082 464H339.335C345.7 464 351.805 466.529 356.306 471.029C360.806 475.53 363.335 481.635 363.335 488ZM471.888 239.03L357.837 124.978C355.618 122.709 352.97 120.902 350.047 119.663C347.125 118.424 343.986 117.777 340.811 117.759C337.637 117.741 334.491 118.354 331.555 119.56C328.619 120.767 325.951 122.544 323.707 124.789C321.463 127.034 319.686 129.701 318.479 132.638C317.273 135.574 316.661 138.72 316.679 141.894C316.697 145.069 317.344 148.208 318.584 151.13C319.823 154.052 321.63 156.7 323.9 158.919L396.977 232H208.041C201.676 232 195.571 234.529 191.07 239.029C186.57 243.53 184.041 249.635 184.041 256C184.041 262.365 186.57 268.47 191.07 272.971C195.571 277.471 201.676 280 208.041 280H396.976L323.896 353.08C321.657 355.306 319.88 357.953 318.666 360.867C317.452 363.781 316.825 366.907 316.82 370.064C316.816 373.221 317.435 376.348 318.641 379.266C319.847 382.184 321.617 384.835 323.85 387.067C326.082 389.3 328.733 391.07 331.651 392.276C334.569 393.482 337.696 394.101 340.853 394.097C344.01 394.092 347.136 393.465 350.05 392.251C352.964 391.037 355.611 389.26 357.837 387.021L471.888 272.971C476.389 268.47 478.917 262.366 478.917 256C478.917 249.635 476.389 243.531 471.888 239.03Z"
                        fill="#0059bf" />
                    </svg>
                    <span class="sr-only">Logout</span>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    </div>

    <div class="d-flex">
      <div class="container-fluid overallSec clearfix pt-md-2 pt-2" [class.active]="active">
        <router-outlet></router-outlet>
      </div>
      @if (activityLogPageload | async) {
        <div class="pt-md-4 pt-2 active-log" [class.active]="active">
          <app-activity-logs></app-activity-logs>
        </div>
      }
    </div>
  </div>
</div>

@if (chatbotEnable) {
  <app-chat-widget botName="Cardinality" theme="blue"></app-chat-widget>
}

<!-- main loader -->
<div id="loaderAnimation" class="loaderAnimation">
  <div class="loadingGifAnimation clearfix">
    <div class="loadingInner clearfix">
      <img class="logoCenterLoading" src="assets/images/Loader-new.gif" alt="Loading" />
    </div>
  </div>
</div>

<p-dialog
  class="clsDialogCloseIconRemove"
  (onHide)="close()"
  [visible]="visible"
  [modal]="true"
  [focusTrap]="true"
  [dismissableMask]="true"
  [closeOnEscape]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '60vw' }"
  [resizable]="false"
  [attr.aria-labelledby]="visible ? 'dialog-title-trans' : null"
  [attr.role]="visible ? 'dialog' : null"
  [attr.aria-describedby]="visible ? 'dialog-content-trans' : null">
  <ng-template pTemplate="header">
    <div class="d-flex align-items-center justify-content-between">
      <div class="clearfix">
        <h2 id="dialog-title-trans" class="clearfix no-mar clsDialogTitle">
          Automatic Translation Disclaimer<br />
          Descargo de responsabilidad por traducción automática
        </h2>
      </div>
      <button #accept type="button" class="btn btn-link no-mar clsCloseBtn" (click)="close()" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" fill="none">
          <path
            d="M38.57 29.0019L56.5131 11.0588C58.4956 9.07625 58.4956 5.86208 56.5131 3.88265L54.1211 1.49061C52.1379 -0.492534 48.9238 -0.492534 46.9443 1.49061L29.0019 19.4331L11.0588 1.48689C9.07625 -0.495631 5.86208 -0.495631 3.88265 1.48689L1.48689 3.87893C-0.495631 5.86208 -0.495631 9.07625 1.48689 11.0557L19.4331 29.0019L1.49061 46.9443C-0.492534 48.9275 -0.492534 52.1416 1.49061 54.1211L3.88265 56.5131C5.86518 58.4956 9.07934 58.4956 11.0588 56.5131L29.0019 38.57L46.9443 56.5131C48.9275 58.4956 52.1416 58.4956 54.1211 56.5131L56.5131 54.1211C58.4956 52.1379 58.4956 48.9238 56.5131 46.9443L38.57 29.0019Z" />
        </svg>
      </button>
    </div>
  </ng-template>

  <div class="clearfix mb-4 clsTranslation">
    <p class="mb-3" id="dialog-content-trans">
      The State of West Virginia provides automatic translation for Communication & Operations Mobile Engagement Tool
      into two languages, courtesy of Google Translate. Please remember, though, that the English language version is
      considered the most accurate. In the event of a disagreement or discrepancy between the translation and the
      original English version of this web site or any notice or disclaimer, the original English version will prevail.
      <br /><br />
      El Estado de West Virginia proporciona traducción automática para Communication & Operations Mobile Engagement
      Tool a dos idiomas, por cortesía de Google Translate. No obstante, recuerde que la versión en inglés se considera
      la más exacta. En caso de desacuerdo o discrepancia entre la traducción y la versión original en inglés de este
      sitio web o cualquier aviso o descargo de responsabilidad, prevalecerá la versión original inglés.
    </p>
  </div>

  <ng-template pTemplate="footer">
    <div class="clearfix sep-top clsMarMinus"></div>
    <div class="clearfix pt-3 text-right">
      <button type="button" class="btn btn-primary" (click)="acceptLanguage()">Accept / Aceptar</button>
      <button type="button" class="btn btn-cancel ms-3" (click)="close()">Do Not Accept / No Aceptar</button>
    </div>
  </ng-template>
</p-dialog>

<app-switch-role [showSwitchRoleModal]="showSwitchRoleModal" (closeModal)="showSwitchRoleModal = false">
</app-switch-role>
